"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4490,4376],{

/***/ 72523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var ab_cards__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84691);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4351);



var RegaleExperiencia = function(param) {
    var classname = param.classname, moduloCross = param.moduloCross, i18n = param.i18n;
    var disfrute = moduloCross === null || moduloCross === void 0 ? void 0 : moduloCross.modCrossRegaleExperiencia;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common", {
        i18n: i18n
    }).t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_cards__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: classname,
        title: i18n.language == "en" ? (disfrute === null || disfrute === void 0 ? void 0 : disfrute.titleregaleen) || (disfrute === null || disfrute === void 0 ? void 0 : disfrute.titleregale) : i18n.language == "de" ? (disfrute === null || disfrute === void 0 ? void 0 : disfrute.titleregalede) || (disfrute === null || disfrute === void 0 ? void 0 : disfrute.titleregale) : disfrute === null || disfrute === void 0 ? void 0 : disfrute.titleregale,
        cards: disfrute === null || disfrute === void 0 ? void 0 : disfrute.cardsregale,
        text: disfrute === null || disfrute === void 0 ? void 0 : disfrute.textregale,
        animated: disfrute === null || disfrute === void 0 ? void 0 : disfrute.animatedregale,
        link: classname == "hide-ver-todos" ? null : {
            text: t("ver-todas-experiencias"),
            href: t("/tienda/bono-regalo-experience-box/")
        },
        linkBefore: true,
        i18n: i18n
    });
};
/* harmony default export */ __webpack_exports__["default"] = (RegaleExperiencia);


/***/ })

}]);